export default __webpack_public_path__ + "static/media/kendoka.c7095d9c.png";